module.exports = __webpack_public_path__ + "static/media/coronavirus-green.6f7ac2ea.png";